module.exports = __webpack_public_path__ + "static/media/schedule_black_24dp.32d4d23a.svg";